import { AppParagraph } from "@/shared/Components";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  subtitle?: string;
};

export const MainPageTitle = ({ title, subtitle }: Props) => {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle && (
        <AppParagraph size="sm" className={styles.subtitle}>
          {subtitle}
        </AppParagraph>
      )}
    </div>
  );
};
